import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT = 1024;

const matches = (breakpoint: number): boolean => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
};

/**
 * 响应式判断当前视口是否为移动端宽度。
 * 使用 `matchMedia` + `change` 事件，比 `resize` 节流且省电。
 */
export const useIsMobile = (breakpoint: number = DEFAULT_BREAKPOINT): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(() => matches(breakpoint));

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [breakpoint]);

    return isMobile;
};
